/*
 * "RESTRICT PAGE BOX REORDERING AND DELETING" (Chris, 2026-10-25): a recipient who has never seen a replay can scramble or delete the owner's page boxes and lose the view the owner meant them to have. When the owner
 * leaves this on (it is on by default) the viewer keeps the boxes where the owner put them: no dragging to reorder, no dragging to remove, no automatic sorting. Every other view option still works.
 * A module of its own so the dashboard code can ask without importing the share viewer.
 */
let locked = false;

export const setBoxesLocked = (on: boolean) => { locked = on; };
export const boxesLocked = (): boolean => locked;
